import { render, staticRenderFns } from "./edit-exhibition-live.vue?vue&type=template&id=042c8b84&scoped=true&"
import script from "./edit-exhibition-live.vue?vue&type=script&lang=js&"
export * from "./edit-exhibition-live.vue?vue&type=script&lang=js&"
import style0 from "./edit-exhibition-live.vue?vue&type=style&index=0&id=042c8b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c8b84",
  null
  
)

export default component.exports